export const enum ToxicFilterModeEnum {
  Toxic = 'Toxic',
  VeryToxic = 'VeryToxic',
  Risk = 'Risk',
}
